import { colors } from "assets";

export default {
  subheader: {
    lineHeight: "20px",
    paddingLeft: 0
  },
  rootRadioButton: {
    width: "auto",
    paddingLeft: 20
  },
  labelRadioButton: {
    width: "100%",
    fontFamily: "Source Sans Pro",
    fontSize: "1.0em",
    fontWeight: "bold",
    cursor: "pointer",
    color: "#222"
  },
  colorRadioButton: {
    fill: colors.checkbox.normal
  },
  colorUncheckedRadioButton: {
    fill: "#7B7D7F"
  },
  labelOptionRadioButton: {
    fontSize: "0.9em"
  },
  rootRadioButtonGroup: {
    display: "flex"
  }
};



// WEBPACK FOOTER //
// ./src/components/app/registration/customer/form/custom-info/styles.js